exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[data-role=\"demo\"] .block {\n  padding: 20px;\n  margin-bottom: 50px;\n}\ndiv[data-role=\"demo\"] .markdown-container {\n  padding: 20px 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ce5b23b","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=2!./src/Resource/Demo.vue
// module id = d6V7
// module chunks = 1